module.exports = __webpack_public_path__ + "img/aica-logo.bd660e0a.png";